// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ranking[data-v-10665a3d]{animation:skeleton-gradient-10665a3d 1.8s ease-in-out infinite;background-color:#e9e9e9;border-radius:8px}@media(max-width:985px){.ranking[data-v-10665a3d]{height:488px}}@media(min-width:986px){.ranking[data-v-10665a3d]{height:411px}}@keyframes skeleton-gradient-10665a3d{0%{background-color:hsla(0,0%,65%,.1)}50%{background-color:hsla(0,0%,65%,.3)}to{background-color:hsla(0,0%,65%,.1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
